<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.sysText.editDocument_title | titlecase }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      [control]="documentTitle"
      [label]="data.sysText.documentTitle"
      [inputType]="'string'"
      [icon]="'comment'">
    </app-input-field>
    <app-select-field
      [group]="form"
      [control]="documentCategoryId"
      [options]="data.options.categories"
      [icon]="'list'"
      [label]="data.sysText.documentCategory"
      [shouldCapitalize]="false">
    </app-select-field>
    @if (showDateReceived) {
      <app-date-field
        [control]="dateReceived"
        [label]="data.sysText.dateReceived"
        [icon]="'calendar_today'">
      </app-date-field>
    }
    <app-input-field
      [control]="documentComments"
      [label]="data.sysText.documentComments"
      [inputType]="'string'"
      [icon]="'comment'">
    </app-input-field>
    @if (data.mode == docUploadMode.Employee) {
      <div class="select-container">
        <mat-icon [ngClass]="{ focus: select.focused }">assignment_turned_in</mat-icon>
        <mat-form-field color="accent">
          <mat-label>{{ data.sysText.associatedCase | titlecase }}</mat-label>
          <mat-select #select="matSelect" [formControl]="associatedCase" disableOptionCentering panelClass="dropDownSelect" panelWidth="fit-content">
            <mat-select-trigger>
              {{associatedCase.value}}
            </mat-select-trigger>
            @for (case of data.options.cases; track case) {
              <mat-option [value]="case.caseId">
                <span>{{ case.caseId }}</span>
                @if (case.leaveType) {
                  <span class="caption option-extras">{{ case.leaveType }}</span>
                }
                @if (case.startDate) {
                  <span class="caption option-extras">@if (case.leaveType) {
                    <span class="bullet-spacing">&bull;</span>
                  }{{ data.sysText.caseLeaveInfo_started | titlecase }} {{case.startDate | date}}</span>
                }
              </mat-option>
            }
          </mat-select>
          @if (data.options.cases?.length === 0) {
            <mat-hint>{{ data.sysText.noCases }}</mat-hint>
          }
        </mat-form-field>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>